<template>
  <base-pitch-type-card
    :available-to-search="availableToSearch"
    :pitchtype="pitchtype"
    :pitchtype-index="pitchtypeIndex"
    :is-available="partyValidation.isAvailable"
    :is-over-capacity="partyValidation.isOverCapacity"
    :party="party"
    :campsite-categories="campsiteCategories"
    :campsite-slug="campsiteSlug"
    :campsite-hierarchy-path="campsiteHierarchyPath"
    :calendar-start-date="calendarStartDate"
  >
    <template #status-msg>
      <div
        v-if="partyValidation.isOverCapacity"
        class="pt-status-msg ct-status-msg"
      >
        <img src="@/assets/images/warning.svg" width="15" height="15" alt="" />
        <translate v-if="partyValidation.violation === 'adults_only'">
          Adults only
        </translate>
        <translate
          v-else-if="partyValidation.violation === 'humans'"
          :tt="{ amount: partyValidation.capacityDetails?.maxPeople }"
        >
          {amount, plural, one{# person maximum} other{# people maximum}}
        </translate>
        <translate
          v-else-if="
            partyValidation.violation === 'dogs' &&
            partyValidation.capacityDetails?.maxDogs === 0
          "
        >
          Dogs not allowed
        </translate>
        <translate
          v-else-if="partyValidation.violation === 'dogs'"
          :tt="{ amount: partyValidation.capacityDetails?.maxDogs }"
        >
          Exceeds max. {amount, plural, one{dog} other{dogs}} ({amount})
        </translate>
        <translate v-else> Party size exceeds capacity </translate>
      </div>
      <div
        v-else-if="showOffersLosenge"
        class="status"
        :class="{ desktop: $isDesktop }"
      >
        <img
          src="@/assets/images/star-outline.svg"
          alt=""
          width="15"
          height="15"
        />
        <translate>Offer</translate>
      </div>
    </template>
    <template #state>
      <pitch-type-state :pitchtype="pitchtype" />
    </template>
  </base-pitch-type-card>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { CampsiteCategory } from '~/utility/types/CampsiteCategory'
import type { PitchType } from '../../../campsite-details/types'
import type { SearchParty } from '~/apps/search/schemas'
import { validatePitchtypeCapacity } from '~/utility/campsite/party-validation'

@Component
class PitchTypeCard extends Vue {
  @Prop({ required: true, type: Object })
  pitchtype: PitchType

  @Prop()
  availableToSearch: boolean

  @Prop({ required: true, type: String })
  campsiteHierarchyPath: string

  @Prop({ required: true })
  campsiteCategories: CampsiteCategory[]

  @Prop({ required: true, type: String })
  campsiteSlug: string

  @Prop({ default: null })
  pitchtypeIndex: number | null

  @Prop()
  calendarStartDate: string

  @Prop({ required: true })
  party: SearchParty

  @Prop({ default: false })
  campsiteAdultsOnly: boolean

  get showOffersLosenge() {
    return this.pitchtype.activeOffers.length > 0
  }

  get partyValidation() {
    return validatePitchtypeCapacity(this.party, this.pitchtype, {
      adultsOnly: this.campsiteAdultsOnly,
    })
  }
}

export default toNative(PitchTypeCard)
</script>
<style scoped>
.extras-title {
  color: #4f849d;
  margin: 1em 0 0.2em 0;
  font-weight: bold;
}

.status {
  color: var(--colour-offers);
  font-size: var(--small);
  margin-left: 1em;
  display: flex;
  line-height: 1;
}

.status img {
  width: auto;
  height: 1.1em;
  margin-right: 0.25em;
}

.status span {
  flex-shrink: 0;
}

/* desktop & tablet */
.desktop .status {
  margin: 0;
}
</style>
